import { useEffect, useState } from "react";
import HospitalsTable from "../../components/hospitals/HospitalsTable";
import { getAllHospitals } from "../../services/superAdmin.service";
import { Building2, Activity, Users } from "lucide-react";

const SuperAdminDashboard = () => {
  const [hospitals, setHospitals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const loadHospitals = async () => {
    setLoading(true);
    const data = await getAllHospitals();
    setHospitals(data);
    setLoading(false);
  };

  useEffect(() => {
    loadHospitals();
  }, []);

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Dashboard</h1>
        <p className="text-gray-500 mt-1">Overview of all registered hospitals and their status.</p>
      </div>

      {/* Stats Overview - Optional improvements if data existed, for now just a placeholder visual or clean separation */}

      {/* Main Content Area */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between bg-gray-50/50">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <Building2 className="w-5 h-5 text-gray-400" />
            Registered Hospitals
          </h2>
          <div className="px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs font-medium">
            Total: {hospitals.length}
          </div>
        </div>

        <div className="p-0">
          {loading ? (
            <div className="p-12 text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
              <p className="text-gray-500 animate-pulse">Loading hospital records...</p>
            </div>
          ) : (
            <HospitalsTable hospitals={hospitals} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
